// @flow
import AdvertisementTemplatesTable from './AdvertisementTemplatesTable'
import { connect } from 'react-redux'
import * as reducer from '../redux/ducks/advertisementTemplatesTable/reducers'
import type { State } from '../redux/ducks/advertisementTemplatesTable/reducers'
import type { Store } from '../redux/ducks'
import getJson from '../services/getJson'
import _ from 'lodash'

const GET_TEMPLATES_PATH = '/advertisement_templates'

function mapStateToProps(state: Store, ownProps) {
  const {
    templateList,
    audienceList,
    archivedTemplateIds,
    tableGroupType,
    checkedTemplateIds
  } = state.advertisementTemplatesTable
  const currentTemplateList = _.reject(templateList, (item) =>
    _.includes(archivedTemplateIds, item.id)
  )
  const currentAudienceList = _.reject(audienceList, (item) => {
    return _.every(item.advertisements, (advertisement) =>
      _.includes(archivedTemplateIds, advertisement.entity_id)
    )
  })
  const groupByTemplates = _.isEqual(tableGroupType, 'templates')
  const checkedItemIds = groupByTemplates
    ? checkedTemplateIds
    : _.map(
        _.filter(currentAudienceList, (audience) => {
          return _.every(audience.advertisements, (advertisement) =>
            _.includes(checkedTemplateIds, advertisement.entity_id)
          )
        }),
        'id'
      )
  return {
    ...ownProps,
    ...state.advertisementTemplatesTable,
    groupByTemplates: groupByTemplates,
    templateList: currentTemplateList,
    audienceList: currentAudienceList,
    checkedItemIds
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (diff: $Shape<State>) => {
      dispatch(reducer.patch(diff))
    },
    onInit: () => {
      getRequest(dispatch, { table_group_type: 'templates' })
    },
    onDatepickerChange: (dates: string) => {
      dispatch(reducer.patch({ isLoading: true }))
      getRequest(dispatch, { datepicker: dates })
    },
    onTableGroupTypeChange: (tableGroupType: string) => {
      dispatch(reducer.patch({ isLoading: true }))
      getRequest(dispatch, { table_group_type: tableGroupType })
    }
  }
}

function getRequest(dispatch: Function, data: Object) {
  getJson(GET_TEMPLATES_PATH, data)
    .done((response: Object) => {
      dispatch(
        reducer.patch({
          templateList: response.result.templateList,
          audienceList: response.result.audienceList,
          tableGroupType: response.result.tableGroupType
        })
      )
    })
    .fail(() => window.alert('Internal error'))
    .always(() => dispatch(reducer.patch({ isLoading: false })))
}

const AdvertisementTemplatesTableContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AdvertisementTemplatesTable)

export default AdvertisementTemplatesTableContainer
